import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Utils } from "../../../Utils";
import { Helpers } from "../../../Helpers";
import Loader from "../../Loader";

function KpiGrowthIndex({ data = {}, isStatic = false }) {
  const currentOrg = useSelector((state) => state?.org);
  const { subModuleData, isDashboardLoading } = useSelector(
    (state) => state?.dashboardComponents
  );
  const [countData, setCountData] = useState(0);
  const [previousCountData, setPreviousCountData] = useState(400);
  const [percentageChange, setPercentageChange] = useState(-13.11);
  console.log('percentageChange', percentageChange);
  const [periodLabel, setPeriodLabel] = useState("Revenue This Month");
  const [previousPeriodLabel, setPreviousPeriodLabel] =
    useState("Previous Month");
let count = 500;

     useEffect(() => {
          Utils.calculateKpiData(subModuleData, data, Utils, setCountData, setPreviousCountData, setPercentageChange, setPeriodLabel, setPreviousPeriodLabel);
        }, [subModuleData?.[data?.moduleId], data]);


  return (
    <>
      {isDashboardLoading && !countData ? (
        <div className="chart-loader">
          <Loader type={"infinitySpin"} isVisible={true} />
        </div>
      ) : (
        <div
          style={{
            maxWidth: "300px",
            margin: "0 auto",
            padding: "1px",
            border: "0px solid #ccc",
            borderRadius: "8px",
          }}
        >
          {countData > 0 || isStatic ? (
            <>
          <h6
            className="card-title"
            style={{ fontSize: "14px", marginBottom: "1px" }}
          >
           {isStatic ? ( <span>{periodLabel}</span>) : (<span>{data?.field} {Utils.periodLabelMapping[periodLabel]}</span>)}
          </h6>
          <h2
            className="fw-bold"
            style={{ fontSize: "14px", marginBottom: "1px" }}
          >
            {isStatic ? (
              <span> {Utils.checkCurrency(count, data, currentOrg, isStatic)}</span>
            ) : ( <span> {Utils.checkCurrency(countData, data, currentOrg, isStatic)}</span> )}
           
            {percentageChange !== null && (
              <span
                className={`text-${
                  percentageChange >= 0 ? "success" : "danger"
                }`}
                style={{ fontSize: "16px", marginLeft: "5px" }}
              >
                {Math.abs(percentageChange).toFixed(2)}%
              </span>
            )}
          </h2>
          <p style={{ fontSize: "12px", color: "#666", marginBottom: "1px" }}>
            {isStatic ? (<span>{previousPeriodLabel}</span>) : (<span>{Utils.periodLabelMapping[previousPeriodLabel]}</span>)} : {Utils.checkCurrency(previousCountData, data, currentOrg, isStatic)}
          </p>
          </>
          ) : (
            <div className="h-100 text-secondary align-self-center align-center py-3">
            No Data Found
          </div>
        )}
      </div>
          )}
      {isStatic && <small className="text-muted">Growth Index</small>}
    </>
  );
}

export default KpiGrowthIndex;
